module.exports = __webpack_public_path__ + "static/media/portfolio.2e226302.png";